import { EmphasisBanner } from '@uhg-abyss/web/ui/EmphasisBanner';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { find } from 'lodash';
import React from 'react';

import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';

const testId = 'laww-sign-in-banner-alert';

export const LawwSignInAlert: React.FC = () => {
  const getUiMessaging = useLagoon('ui-messaging') as () => Array<{
    key?: string;
    message?: string;
    url?: string;
  }>;
  const lagoonUIMessage = getUiMessaging();
  const signInMsg = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.SIGN_IN_ALERT_MESSAGE,
  })?.message;
  const signInHeader = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.SIGN_IN_ALERT_HEADER,
  })?.message;
  const signInURL = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.SIGN_IN_ALERT_URL,
  })?.url;
  const signInButtonMsg = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.SIGN_IN_ALERT_URL,
  })?.message;
  const resolvedSignInMsg = signInMsg || '';
  const resolvedSignInHeader = signInHeader || '';
  const resolvedSignInURL = signInURL || '';

  const handleSignInClick = () => {
    if (!resolvedSignInURL) {
      return;
    }
    if (!resolvedSignInURL.startsWith('https://')) {
      return;
    }
    window.top?.location.assign(resolvedSignInURL);
  };

  return (
    <Layout.Insert>
      <Flex
        css={{
          width: '100%',
          justifyContent: 'center',
          backgroundColor: 'rgba(176, 227, 234, 1)',
          '& .laww-signin-custom-icon': {
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: 'rgba(25, 110, 207, 1)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            alignSelf: 'center',
          },
          '& .laww-signin-custom-icon .abyss-icon-symbol': {
            color: 'white',
          },
        }}
      >
        <Flex css={{ flexDirection: 'row', maxWidth: '1200px', width: '100%' }}>
          <div className="laww-signin-custom-icon">
            <IconSymbol icon="info" />
          </div>
          <EmphasisBanner
            className="laww-signin-alert abyss-emphasis-banner-root"
            color="emphasis4"
            css={{
              'abyss-emphasis-banner-root': {
                flex: 1,
                paddingLeft: '0px',
                backgroundColor: 'transparent',
                '& .abyss-emphasis-banner-wrapper': {
                  width: '100%',
                },
              },
            }}
            cta={{
              secondaryButton: {
                children: signInButtonMsg,
                onClick: handleSignInClick,
              },
            }}
            data-testid={testId}
            dismissible={false}
            onClose={() => {}}
            title={resolvedSignInHeader}
          >
            {resolvedSignInMsg}
          </EmphasisBanner>
        </Flex>
      </Flex>
    </Layout.Insert>
  );
};
